import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function SelectLanguage(props) {
  const { t } = useTranslation();
  const { type, setType } = props;

  const tw = "zh-TW";
  const cn = "zh-CN";
  const enCanonical = "en-US";

  useEffect(() => {
    setType(type);
  }, [setType, type]);

  const handleTypeChange = (lng) => {
    // When selecting English, use the canonical 'en-US' value.
    if (lng === "en") {
      setType(enCanonical);
      return;
    }
    setType(lng);
  };

  const isEnSelected = !!type && type.startsWith("en");
  const isCnSelected = type === cn;
  const isTwSelected = type === tw;

  return (
    <div
      className="btn-group"
      role="group"
      aria-label="Basic radio toggle button group"
    >
      <input type="radio" className="btn-check" checked={isEnSelected} readOnly />
      <label className="btn btn-outline-primary" onClick={() => handleTypeChange("en")}>{t("setting.en")}</label>

      <input type="radio" className="btn-check" checked={isCnSelected} readOnly />
      <label className="btn btn-outline-primary" onClick={() => handleTypeChange(cn)}>{t("setting.cn")}</label>

      <input type="radio" className="btn-check" checked={isTwSelected} readOnly />
      <label className="btn btn-outline-primary" onClick={() => handleTypeChange(tw)}>{t("setting.tw")}</label>
    </div>
  );
}